import React from 'react';
const PipeOpenEnd1Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 56.254 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="18.7893" y1="112.5" x2="18.7893" y2="4.882813e-004">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
        <radialGradient id={`${id}_2`} cx="37.6824" cy="37.7461" r="37.8042" gradientTransform="matrix(0.5005 0 0 1.5015 18.4553 -0.4249)" gradientUnits="userSpaceOnUse">
          <stop offset="0.01" stopColor="#4C4C4C" />
          <stop offset="0.68" stopColor="#ABABAB" />
          <stop offset="0.82" stopColor="#F4F4F4" />
          <stop offset="1" stopColor="#585858" />
        </radialGradient>
        <linearGradient id={`${id}_3`} gradientUnits="userSpaceOnUse" x1="22.7922" y1="56.75" x2="51.8386" y2="56.75">
          <stop offset="0" stopColor="#323232" />
          <stop offset="0.56" stopColor="#000000" />
          <stop offset="1" stopColor="#323232" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}_1)`} d="M0.002,0h37.575v112.5H0.002V0z" />
      <ellipse fill={`url(#${id}_2)`} cx="37.315" cy="56.25" rx="18.938" ry="56.25" />
      <path fill={`url(#${id}_3)`} d="M37.315,105.838c-19.364,0-19.364-98.175,0-98.175C56.679,7.663,56.679,105.838,37.315,105.838z" />
    </svg>
  );
};
export default PipeOpenEnd1Icon;
